import { ClearGoalsForm } from 'source/app/presentation/MainPanel/Goals/RemoveFilters/RemoveFilters';
import { ClearLogForm } from '../../presentation/MainPanel/Log/Log';

export function ClearInputForms() {
    ClearLogForm();
    ClearGoalsForm();
}
